<div class="scroll-progress d-none d-xxl-block">
  <a href="#" class="scroll-top" aria-label="scroll" (click)="scrollToTop(); $event.preventDefault()">
    <span class="scroll-text">Scroll</span>
    <span class="scroll-line">
      <span class="scroll-point"></span>
    </span>
  </a>
</div>

